(() => {
  const KEY_DEFAULT = 'pv_promo_popup_seen';

  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';

    const key = root.dataset.storageKey || KEY_DEFAULT;
    try {
      if (sessionStorage.getItem(key) === '1') return;
    } catch (_) {
      /* private mode — still show once this page load via dataset */
      if (root.dataset.shown === '1') return;
    }

    const delay = Math.max(0, Number(root.dataset.delay) || 800);
    const closeBtns = root.querySelectorAll('[data-pv-promo-close]');

    const close = () => {
      root.hidden = true;
      document.body.classList.remove('pv-promo-popup-open');
      try {
        sessionStorage.setItem(key, '1');
      } catch (_) {
        root.dataset.shown = '1';
      }
      document.removeEventListener('keydown', onKey);
    };

    const onKey = (event) => {
      if (event.key === 'Escape') close();
    };

    const open = () => {
      root.hidden = false;
      document.body.classList.add('pv-promo-popup-open');
      document.addEventListener('keydown', onKey);
      const focusBtn = root.querySelector('.pv-promo-popup__cta') || root.querySelector('[data-pv-promo-close]');
      focusBtn?.focus?.();
    };

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        if (btn.tagName === 'A') {
          try {
            sessionStorage.setItem(key, '1');
          } catch (_) {
            root.dataset.shown = '1';
          }
          document.body.classList.remove('pv-promo-popup-open');
          return;
        }
        event.preventDefault();
        close();
      });
    });

    window.setTimeout(open, delay);
  }

  const boot = () => document.querySelectorAll('[data-pv-promo-popup]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-pv-promo-popup]')?.forEach(init);
  });
})();
